(() => {
  const initialize = () => {
    document.querySelectorAll('[data-nd-guide-toc]').forEach((navigation) => {
      if (navigation.dataset.ready === 'true') return;
      const scope = navigation.closest('[data-nd-guide-scope]');
      if (!scope) return;
      const headings = Array.from(scope.querySelectorAll('[data-nd-guide-body] h2, [data-nd-guide-body] h3')).filter(h => h.textContent.trim());
      if (headings.length < 2) return;
      navigation.dataset.ready = 'true';
      const list = document.createElement('ol');
      headings.forEach((heading, index) => {
        if (!heading.id) {
          const base = `nd-guide-${index + 1}`;
          let id = base, suffix = 1;
          while (document.getElementById(id)) id = `${base}-${suffix++}`;
          heading.id = id;
        }
        const item = document.createElement('li');
        const link = document.createElement('a');
        link.className = 'link';
        link.href = `#${encodeURIComponent(heading.id)}`;
        link.textContent = heading.textContent.trim();
        item.append(link); list.append(item);
      });
      navigation.append(list); navigation.hidden = false;
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, {once: true});
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
